export default "__VITE_ASSET__BMwfuK1M__"